import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  // Desliga a restauração automática do navegador
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      const prev = (window.history as any).scrollRestoration;
      window.history.scrollRestoration = 'manual';
      return () => { (window.history as any).scrollRestoration = prev ?? 'auto'; };
    }
  }, []);

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        (el as HTMLElement).scrollIntoView({ behavior: 'auto', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
